import Vue from 'vue';

let month = Vue.filter("currency", function (value) {
    let c = parseFloat(value).toFixed(2);
    return isNaN(c) ? "" : (c + " PLN");
});

export default month;